import React from 'react'
import SectionBase from './SectionBase'

export default () => (
  <SectionBase
    titleText="Create an engaging group event for your local community. We'll create a marketing page for you on pga.com and handle all the registrations."
    gtmLearnObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'create-group-event',
      onboardingAction: 'click-learn-more',
    }}
    learnMoreLink="https://support.pga.com/en/articles/5569328-group-events-quick-start"
    gtmDoActionObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'create-group-event',
      onboardingAction: 'click-get-started',
    }}
    doActionLink="/pga-coach/bookings/events"
    doActionText="Create Group Event"
  />
)
